import { FuelImportEntity, FuelImportFilter } from '../../models'

export const SET_FUEL_IMPORTS = 'SET_FUEL_IMPORTS'
export const SET_FUEL_IMPORTS_LOADED = 'SET_FUEL_IMPORTS_LOADED'
export const SET_SELECTED_FUEL_IMPORT = 'SET_SELECTED_FUEL_IMPORT'
export const SET_FUEL_IMPORT_FILTER = 'SET_FUEL_IMPORT_FILTER'

export interface FuelImportState {
  fuelImports: FuelImportEntity[]
  isFuelImportsLoaded: boolean
  selectedFuelImport?: FuelImportEntity
  fuelImportFilter: FuelImportFilter
}

interface SetFuelImportsAction {
  type: typeof SET_FUEL_IMPORTS
  payload: FuelImportEntity[]
}

interface SetFuelImportLoadedAction {
  type: typeof SET_FUEL_IMPORTS_LOADED
  payload: boolean
}

interface SetSelectedFuelImport {
  type: typeof SET_SELECTED_FUEL_IMPORT
  payload?: FuelImportEntity
}

interface SetFuelImportFilterAction {
  type: typeof SET_FUEL_IMPORT_FILTER
  payload: FuelImportFilter
}

export type FuelImportAction =
  | SetFuelImportsAction
  | SetFuelImportLoadedAction
  | SetSelectedFuelImport
  | SetFuelImportFilterAction
